module.exports = __webpack_public_path__ + "media/22.b7551330.wav";